import React from 'react';
import RowClick from '../../../common/RowClick';
import TextBlink from '../../../common/table/TextBlink';
import CellHover from '../../../market/watchlist/summary/CellHover';
import {
  REDUCER_NAME,
  intervalFetchPriceVolume,
  loadMorePriceVolume,
} from './reducer';
import { connect } from 'react-redux';
import Table from '../../../common/table/Table';
import Const from './Const';
import { getColorPrice } from '../../../helpers/Color';
import { getDataFollowKeyByDot, getRanking } from '../../../helpers/Common';
import { I18n } from 'react-redux-i18n';
import {
  formatPrice,
  formatTextFloat,
  formatVolume,
} from '../../../helpers/Text';
import { compose } from 'redux';
import TradingViewUrl from '../../../common/TradingViewUrl';

class PriceVolumeTable extends React.Component {
  constructor(props) {
    super(props);
    this.initialState = {
      page: 1,
      pageSize: Const.maxRowData,
    };
    this.state = this.initialState;
  }

  getDataFromRedux = state => state[REDUCER_NAME].listPriceVolumeByTicker;

  getClassName = (item, listColumn) => {
    return getColorPrice(
      getDataFollowKeyByDot(item, listColumn.price),
      getDataFollowKeyByDot(item, listColumn.ref_price),
      getDataFollowKeyByDot(item, listColumn.high_price),
      getDataFollowKeyByDot(item, listColumn.low_price),
      'text',
    );
  };

  handleScroll = e => {
    const { page } = this.state;
    const { totalPage } = this.props;
    const bottom =
      e.target.scrollHeight - Math.round(e.target.scrollTop) ===
      e.target.clientHeight;
    if (page === totalPage) return;
    if (this.props.ids.length < Const.maxRowData) return;
    if (bottom) {
      this.loadMoreActive();
    }
  };
  loadMoreActive = () => {
    const { page } = this.state;
    const {
      loadMorePriceVolume,
      totalPage,
      featureType,
      priceVolumeId,
      isLoading,
    } = this.props;
    if (page === totalPage || isLoading) return;
    this.setState(
      prevState => {
        return {
          page:
            prevState.page === totalPage ? prevState.page : prevState.page + 1,
        };
      },
      () => {
        const { page, pageSize } = this.state;
        loadMorePriceVolume({
          Page: page,
          PageSize: pageSize,
          featureType,
          priceVolumeId,
        });
      },
    );
  };

  getSchema = i18nTitleKey => {
    return Object.keys(Const.listColumn).map(item => {
      const key = Const.listColumn[item];
      const title = `${i18nTitleKey}.${item}`;
      const result = {
        key,
        title,
      };
      if (key === Const.listColumn.ticker) {
        return {
          ...result,
          isString: true,
          render: (text, item) => {
            return (
              <CellHover organCode={item.organCode} isShowDeleteIcon={false}>
                <div className="text-left">
                  <TradingViewUrl
                    code={getDataFollowKeyByDot(item, 'ticker')}
                  />
                  &nbsp;{item.ticker}
                </div>
              </CellHover>
            );
          },
        };
      }

      if (key === Const.listColumn.price) {
        return {
          ...result,
          thStyle: { textAlign: 'right' },
          render: (text, item) => {
            const className = this.getClassName(item, Const.listColumn);
            let styleDis = { display: 'block' };
            return (
              <div className={`${className} text-right`} style={styleDis}>
                <TextBlink item={item} tradingDate="tradingDate">
                  <span>{formatTextFloat(formatPrice(text))}</span>
                </TextBlink>
              </div>
            );
          },
        };
      }
      if (key === Const.listColumn.volume) {
        return {
          ...result,
          thStyle: { textAlign: 'right' },
          render: (text, item) => (
            <TextBlink item={item} tradingDate="tradingDate">
              {formatTextFloat(formatVolume(text))}
            </TextBlink>
          ),
        };
      }
      if (key === Const.listColumn.volume_expected) {
        return {
          ...result,
          thStyle: { textAlign: 'right' },
          render: text => (
            <div className="text-right">
              {formatTextFloat(formatVolume(text))}
            </div>
          ),
        };
      }
      if (key === Const.listColumn.nrOfDay) {
        return {
          ...result,
          thStyle: { textAlign: 'right' },
          render: text => (
            <div className="text-right"> {formatTextFloat(text, 0)}</div>
          ),
        };
      }
      if (key === Const.listColumn.lastClose) {
        return {
          ...result,
          thStyle: { textAlign: 'right' },
          render: text => (
            <div className="text-right">
              {formatTextFloat(formatPrice(text))}
            </div>
          ),
        };
      }
      if (key === Const.listColumn.lastVol) {
        return {
          ...result,
          thStyle: { textAlign: 'right' },
          render: text => (
            <div className="text-right">
              {formatTextFloat(formatVolume(text))}
            </div>
          ),
        };
      }
      if (key === Const.listColumn.RSI) {
        return {
          ...result,
          thStyle: { textAlign: 'right' },
          render: text => (
            <div className="text-right">{formatTextFloat(text, 2)}</div>
          ),
        };
      }
      if (key === Const.listColumn.ranking) {
        return {
          ...result,
          thStyle: { textAlign: 'right', width: 70 },
          thTooltip: I18n.t('table.technical.ranking'),
          render: (rank, item) => {
            const totalRank = getDataFollowKeyByDot(
              item,
              Const.listColumn.totalRank,
            );
            return <> {getRanking(rank, totalRank)} </>;
          },
        };
      }
      return result;
    });
  };

  render() {
    const { ids, isLoading, onSort } = this.props;

    return (
      <RowClick>
        {onRowClick => (
          <Table
            onSort={onSort}
            clickRow={onRowClick}
            thValign="top"
            resizable={true}
            isLoading={isLoading}
            columnDraggable={false}
            rowDraggable={false}
            hideColumns={Const.listHideColumn}
            getDataFromRedux={this.getDataFromRedux}
            ids={ids}
            schema={this.getSchema('tasignals.priceVolumeHeader')}
          />
        )}
      </RowClick>
    );
  }
}

const mapStateToProps = state => {
  return {
    ids: state[REDUCER_NAME].listTickerPriceVolume,
    listPriceVolumeByTicker: state[REDUCER_NAME].listPriceVolumeByTicker,
    featureType: state[REDUCER_NAME].featureType,
    isLoading: state[REDUCER_NAME].isLoading,
    totalPage: state[REDUCER_NAME].totalPage,
    firstPage: state[REDUCER_NAME].firstPage,
    priceVolumeId: state[REDUCER_NAME].priceVolumeId,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    loadMorePriceVolume: params => dispatch(loadMorePriceVolume(params)),
    intervalFetchPriceVolume: featureType =>
      dispatch(intervalFetchPriceVolume(featureType)),
  };
};

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);

export default enhance(PriceVolumeTable);
